import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    fontSize: 14,
    maxWidth: 465,
  },
  avatar: {
    backgroundColor: `${Colors.Orange1} !important`,
    display: 'inline-flex !important',
    marginRight: 11,
    transform: 'scale(.5)',
    cursor: 'pointer',
    verticalAlign: 'sub',
    '& > svg': {
      transform: 'scale(1.25)',
    },
    '&:hover': {
      backgroundColor: Colors.Orange3,
    },
  },
}));

export default useStyles;